var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormTracksSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_11761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_11761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2136 29.9438H16.3062H15.2401L16.8659 27.6036C17.1724 27.1688 17.0525 26.5678 16.586 26.2736C16.133 25.9795 15.5066 26.0946 15.2001 26.5422L12.5349 30.3786C12.335 30.6728 12.3083 31.0564 12.4816 31.3633C12.6548 31.6703 12.988 31.8749 13.3611 31.8749H15.4933L13.8675 34.2151C13.561 34.6499 13.6809 35.2509 14.1474 35.5451C14.3206 35.6602 14.5072 35.7113 14.7071 35.7113C15.0269 35.7113 15.3467 35.5579 15.5333 35.2893L18.1985 31.4529C18.3984 31.1587 18.4251 30.7751 18.2518 30.4682C18.0786 30.1612 17.793 29.9438 17.4198 29.9438H17.2136Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1161_11761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8469 29.9438H23.9395H22.8734L24.4992 27.6036C24.8057 27.1688 24.6858 26.5678 24.2193 26.2736C23.7663 25.9795 23.1399 26.0946 22.8334 26.5422L20.1682 30.3786C19.9683 30.6728 19.9416 31.0564 20.1149 31.3633C20.2881 31.6703 20.6213 31.8749 20.9944 31.8749H23.1266L21.5008 34.2151C21.1943 34.6499 21.3142 35.2509 21.7807 35.5451C21.9539 35.6602 22.1405 35.7113 22.3404 35.7113C22.6602 35.7113 22.98 35.5579 23.1666 35.2893L25.8318 31.4529C26.0317 31.1587 26.0584 30.7751 25.8851 30.4682C25.7119 30.1612 25.4263 29.9438 25.0531 29.9438H24.8469Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1161_11761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 22.3813C9.3125 22.2605 6.42383 19.2922 6.42383 15.6535C6.42383 12.057 9.24453 9.12149 12.7936 8.93516C13.9807 6.19883 16.7064 4.28516 19.8793 4.28516C24.0834 4.28516 27.5029 7.64609 27.5979 11.8273C27.6969 11.8145 27.7965 11.8051 27.8967 11.798C28.0227 11.7887 28.1498 11.784 28.2775 11.784C31.2037 11.784 33.5762 14.1559 33.5762 17.082C33.5762 20.0094 31.2037 22.3813 28.2775 22.3813H13.1516C13.0748 22.3813 12.998 22.3836 12.9219 22.3813Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_11761",
    x: 7.5667,
    y: 21.3113,
    width: 15.6,
    height: 19.1996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1161_11761",
    x: 15.2,
    y: 21.3113,
    width: 15.6,
    height: 19.1996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1161_11761",
    x: 1.62383,
    y: -0.514844,
    width: 36.7523,
    height: 27.6977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_11761"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormTracksSelected);
export default __webpack_public_path__ + "static/media/storm-tracks-selected.1a5f1bcaa519db388336db92933ab62c.svg";
export { ForwardRef as ReactComponent };